import { persistCombineReducers, persistStore, persistReducer } from 'redux-persist';
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE } from 'redux-persist/es/constants';
import storage from 'redux-persist/lib/storage';
import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';

import { reminderSlice } from '@store/reducers/reminderSlice';
import { dealCalculatorSlice } from '@store/reducers/dealCalculatorSlice';
import { contactManagerSlice } from '@store/reducers/contactManagerSlice';
import { gridsSlice } from '@store/reducers/gridsSlice';
import { tabsPersistConfig, tabsSlice } from '@store/reducers/tabsSlice';
import { headerSlice } from '@store/reducers/headerSlice';
import { openMenuSlice } from '@store/reducers/layoutSlice';
import { draftPersistConfig, draftSlice } from './reducers/draftSlice';
import { dealSlice } from './reducers/dealSlice';
import { roundRobinPersistConfig, roundRobinSlice } from './reducers/roundRobinSlice';
import { screenStateSlice } from './reducers/screenStateSlice';

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  blacklist: ['tabs', 'draft'],
};

const persistedReducer = persistCombineReducers(persistConfig, {
  tabs: persistReducer(tabsPersistConfig, tabsSlice.reducer),
  header: headerSlice.reducer,
  grids: gridsSlice.reducer,
  dealCalculator: dealCalculatorSlice.reducer,
  contactManager: contactManagerSlice.reducer,
  reminder: reminderSlice.reducer,
  openedViaBtnMenu: openMenuSlice.reducer,
  draft: persistReducer(draftPersistConfig, draftSlice.reducer),
  isDealStructureChanged: dealSlice.reducer,
  roundRobin: persistReducer(roundRobinPersistConfig, roundRobinSlice.reducer),
  screenState: screenStateSlice.reducer,
});

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const  persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
